import { Injectable, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ScriptInjectorService } from './script-injector.service';
//_satellite.track("add to cart",{name:"wug",price:"12.99",color:"red"})
//_satellite.track("add to cart",{product:{name:"wug",price:"12.99",color:"red"},location:"cart recommendations"})
declare const _satellite: any;
declare const window: Window;
@Injectable()
export class AnalyticsService implements OnInit {

  constructor(private scriptInjectorService: ScriptInjectorService) { }

  ngOnInit(): void {
  }

  trackClicksByContentTypeLineMake(contentType: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("contentTypeTracking", { contentType: contentType });
    }
  }

  trackClicksByContentTypeSearchKeywordLineMake(keywordCategory: string
    , searchKey: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("keywordContentTypeTracking", { keywordCategory: keywordCategory, searchKey: searchKey });
    }
  }

  trackClicksByNoiseCatalogSearchKeywordLineMake(keywordCategory: string
    , mainGroup: string, sporadicOrPermanent: string, seriesFilterList: any[]
    , areaFilterList: any[], componentFilterList: any[]
    , drivingConditionFilterList: any[], weatherConditionFilterList: any[], kindOfNoiseFilterList: any[]) {
    if (typeof _satellite != "undefined") {
      _satellite.track("keywordNoiseCatalogTracking",
        {
          keywordCategory: keywordCategory, mainGroup: mainGroup, sporadicOrPermanent: sporadicOrPermanent
          , seriesFilterList: seriesFilterList, areaFilterList: areaFilterList
          , componentFilterList: componentFilterList, drivingConditionFilterList: drivingConditionFilterList
          , weatherConditionFilterList: weatherConditionFilterList, kindOfNoiseFilterList: kindOfNoiseFilterList
        });
    }
  }

  trackClicksByDocumentsContentTypeLineMake(contentType: string
    , documentName: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsContentTypeTracking", { contentType: contentType, documentName: documentName });
    }
  }

  trackClicksbyAdminUser(contentType: string, documentName: string, userID: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("adminUserClicksTracking", { contentType: contentType, documentName: documentName, userID: userID });
    }
  }

  tracDocumentsAttachmentViewByTypeLineMake(contentType: string
    , documentName: string, attachmentName: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsAttachmentContentTypeTracking", {
        contentType: contentType, documentName: documentName
        , attachmentName: attachmentName
      });
    }
  }
  trackDocumentAttachmentClicksbyAdminUser(contentType: string, documentName: string, attachmentName: string, userID: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("adminUserDocumentAttchmentClicksTracking", { contentType: contentType, documentName: documentName, attachmentName: attachmentName, userID: userID });
    }
  }
  trackClicksByExternalLocationDocumentAttachment(contentType: string, documentName: string, attachmentName: string, userAddress: string, userCity: string, userState: string, userZipCode: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserLocationDocumentAttachmentClicksTracking", {
        contentType: contentType, documentName: documentName, attachmentName: attachmentName,
        userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }
  tracDocumentsTakataRecallByTypeLineMake(contentType: string
    , documentName: string, documentTakataRecall: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsTakataRecallTracking", {
        contentType: contentType, documentName: documentName
        , documentTakataRecall: documentTakataRecall
      });
    }
  }

  tracDocumentsTakataRecallByUser(contentType: string
    , documentName: string, documentTakataRecall: string, userID: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("adminUserTakataRecallTracking", {
        contentType: contentType, documentName: documentName
        , documentTakataRecall: documentTakataRecall, userID: userID
      });
    }
  }
  trackClicksByExternalContentTakataRecallType(contentType: string
    , documentName: string, documentTakataRecall: string, userAddress: string, userCity: string, userState: string, userZipCode: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserLocationTakataRecallTracking", {
        contentType: contentType, documentName: documentName
        , documentTakataRecall: documentTakataRecall, userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }
  trackRatingByTypeLineMake(contentType: string
    , documentName: string, documentRating: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsRatingTracking", {
        contentType: contentType, documentName: documentName
        , documentRating: documentRating
      });
    }
  }

  trackSavedContentByTypeLineMake(contentType: string
    , documentName: string, documentSaved: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsSavedTracking", {
        contentType: contentType, documentName: documentName
        , documentSaved: documentSaved
      });
    }
  }

  trackSharedContentByTypeLineMake(contentType: string
    , documentName: string, documentShared: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("documentsSharedTracking", {
        contentType: contentType, documentName: documentName
        , documentShared: documentShared
      });
    }
  }

  trackChannelSubscriptionByTypeLineMake(channelNumber: string
    , channelName: string, userName: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("channelSubscriptionTracking", {
        channelNumber: channelNumber, channelName: channelName
        , userName: userName
      });
    }
  }

  trackClicksByExternalContentType(contentType: string, contentName: string, userAddress: string, userCity: string, userState: string, userZipCode: String) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserLocationContentClicksTracking", {
        contentType: contentType, contentName: contentName, userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }
  trackExternalUserLocation(userType: string, userAddress: string, userCity: string, userState: string, userZipCode: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserLocationTracking", {
        userType: userType, userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }
  trackExternalUserLoginWebHits(userType: string, userAddress: string, userCity: string, userState: string, userZipCode: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserWebLoginLocationTracking", {
        userType: userType, userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }
  trackExternalUserLoginMobileHits(userType: string, userAddress: string, userCity: string, userState: string, userZipCode: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("externalUserMobileLoginLocationTracking", {
        userType: userType, userAddress: userAddress, userCity: userCity, userState: userState, userZipCode: userZipCode
      });
    }
  }

  trackErrorByLineMake(errorCode: string, errorDescription: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("tisErrors", { errorCode: errorCode, errorDescription: errorDescription });
    }
  }

  trackModelMapModelValue(modelMapModel: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("modelMapModelTracking", { modelMapModel: modelMapModel });
    }
  }

  trackModelMapSeriesValue(modelMapSeries: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("modelMapSeriesTracking", { modelMapSeries: modelMapSeries });
    }
  }

  trackModelMapYearValue(modelMapYear: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("modelMapYearTracking", { modelMapYear: modelMapYear });
    }
  }

  trackModelMapEngineValue(modelMapEngine: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("modelMapEngineTracking", { modelMapEngine: modelMapEngine });
    }
  }

  trackNewMessageAdded(userID: string, siteSelected: string, messageContent: string, messageAdded: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("messageAddedTracking", {
        userID: userID, siteSelected: siteSelected, messageContent: messageContent
        , messageAdded: messageAdded
      });
    }
  }

  trackNewContentAdded(userID: string, contentType: string, brandName: string, bulletinNumber: string, contentAdded: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("contentAddedTracking", {
        userID: userID, contentType: contentType
        , brandName: brandName, bulletinNumber: bulletinNumber, contentAdded: contentAdded
      });
    }
  }

  trackEditContentUpdated(userID: string, contentType: string, brandName: string, bulletinNumber: string, contentUpdated: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("contentUpdatedTracking", {
        userID: userID, contentType: contentType
        , brandName: brandName, bulletinNumber: bulletinNumber, contentUpdated: contentUpdated
      });
    }
  }

  trackNewThirdPartyUserAdded(userID: string, userAddress: string, userCity: string, userState: string, brandName: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("thirdPartyUserAddedTracking", {
        userID: userID, userAddress: userAddress
        , userCity: userCity, userState: userState, brandName: brandName
      });
    }
  }

  trackNewThirdPartyUserUpdated(userID: string, userAddress: string, userCity: string, userState: string, brandName: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("thirdPartyUserUpdatedTracking", {
        userID: userID, userAddress: userAddress
        , userCity: userCity, userState: userState, brandName: brandName
      });
    }
  }

  trackDealerLoginLocation(centerID: string, locationID: string, marketCode: string,
    marketDescription: string, regionCode: string, regionDescription: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("dealerLoginLocationClicksTrack", {
        centerID: centerID, locationID: locationID, marketCode: marketCode,
        marketDescription: marketDescription, regionCode: regionCode, regionDescription: regionDescription
      });
    }
  }

  trackDealerWebLoginLocation(centerID: string, locationID: string, marketCode: string,
    marketDescription: string, regionCode: string, regionDescription: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("dealerWebLoginLocationClicksTrack", {
        centerID: centerID, locationID: locationID, marketCode: marketCode,
        marketDescription: marketDescription, regionCode: regionCode, regionDescription: regionDescription
      });
    }
  }
  trackDealerMobileLoginLocation(centerID: string, locationID: string, marketCode: string,
    marketDescription: string, regionCode: string, regionDescription: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("dealerMobileLoginLocationClicksTrack", {
        centerID: centerID, locationID: locationID, marketCode: marketCode,
        marketDescription: marketDescription, regionCode: regionCode, regionDescription: regionDescription
      });
    }
  }
  trackDealerContentTypeLocation(contentType: string, documentName: string, centerID: string, locationID: string, marketCode: string,
    marketDescription: string, regionCode: string, regionDescription: string) {
    if (typeof _satellite != "undefined") {
      _satellite.track("dealerContentTypeLocationClicksTrack", {
        contentType: contentType, documentName: documentName, centerID: centerID, locationID: locationID,
        marketCode: marketCode, marketDescription: marketDescription, regionCode: regionCode,
        regionDescription: regionDescription
      });
    }
  }

  initAdobeLaunchDataLayer() {
    //(window as Window).digitalData
  }
  async injectAdobeLaunchScript() {
    try {
      await this.scriptInjectorService.load('launch',
        environment.ADOBE_LAUNCH_SCRIPT_URL
      );
      _satellite.pageBottom();
    }
    catch (e) {
      console.error('Error while loading Adobe Launch Script', e);
    }
  }
}
